import { GlobalOutlined, HomeOutlined, PhoneOutlined } from "@ant-design/icons";
export default function DocumentLogo() {
  return (
    <>
      <div className="border border-black py-4 px-2 flex flex-row justify-between items-center text-xs">
        <div className="w-full sm:w-2/3">
          <div className="flex w-96">
            <img src="https://toyota.co.tz/fileadmin/_processed_/csm_logo_red_904d0f99f9.png" />
          </div>
        </div>
        <div className="flex flex-col w-full sm:w-1/3  ">
          <div className="px-2 font-bold text-lg">Toyota Tanzania Ltd</div>
          <div className="px-2 flex flex-row">
            <div className="mr-2">
              <HomeOutlined />
            </div>
            <div className="flex-col">
              <div className="">Nyerere Road, Plot No. 19</div>
              <div className="">Box 9060, Dar es salaam</div>
            </div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <PhoneOutlined />
            </div>
            <div className=""> (+255) 22 2118990-1</div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <HomeOutlined />
            </div>
            <div className="">sales@toyota.co.tz</div>
          </div>
          <div className="px-2 flex flex-row items-center">
            <div className="mr-2">
              <GlobalOutlined />
            </div>
            <div className="">www.toyota.co.tz</div>
          </div>
        </div>
      </div>
    </>
  );
}
